<div class="section">
  <ion-header no-border class="header-container"
              [ngClass]="{'animation': isDesktop}">
    <pptl-header-main-view></pptl-header-main-view>
  </ion-header>
  <div class="main-container">
    <router-outlet></router-outlet>
  </div>
</div>
